import { supabase } from '@/integrations/supabase/client';

export interface ModoForjaTrack {
  id: string;
  file_name: string;
  file_path: string;
  duration_seconds: number | null;
  is_enabled?: boolean;
}

export const MODOFORJA_ENABLED_TRACKS_QUERY_KEY = ['modoforja-tracks', 'enabled'] as const;

export async function fetchEnabledModoForjaTracks(): Promise<ModoForjaTrack[]> {
  const { data, error } = await supabase
    .from('modoforja_tracks')
    .select('id, file_name, file_path, duration_seconds, is_enabled')
    .eq('is_enabled', true)
    .order('created_at', { ascending: false });

  if (error) {
    throw error;
  }

  return data ?? [];
}